import { IPaneConfiguration } from '../charting/interfaces/IPaneConfiguration';

export class ChartConfigurationOption {
    title: string;
    isTitleVisible: boolean;
    isLegendVisible: boolean;
    isHorizontalGridlinesVisible: boolean;
    isVerticalGridlinesVisible: boolean;
    xAxis: any;
    yAxis: any;
    horizontalLines: any[];
    display: any;
    panes: IPaneConfiguration[];
    hasAbsolutePanesHeight: boolean;
    crosshairDate: Date;
    disableCrosshair?: boolean;
    showXAxis: boolean;
    showYAxis: boolean;

    constructor() {
        this.title = 'Title';
        this.isTitleVisible = true;
        this.isLegendVisible = true;
        this.isHorizontalGridlinesVisible = false;
        this.isVerticalGridlinesVisible = false;
        this.xAxis = {};
        this.yAxis = {};
        this.horizontalLines = [];
        this.display = {
            isHorizontalGridlinesVisible: false,
            isVerticalGridlinesVisible: false
            //yAxisFormat:'f'
        };
        this.crosshairDate = null;
        this.showXAxis = true;
        this.showYAxis = true;
    }
}
